module.exports = __webpack_public_path__ + "img/installiOS.599d67b6.png";